import { defineMessages, type IntlShape } from 'react-intl';

import type { JSONSchema } from '@plone/types';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const addTitleColor = ({
  schema,
  formData,
  intl,
}: {
  schema: JSONSchema;
  formData: JSONSchema;
  intl: IntlShape;
}): JSONSchema => {
  addStyling({ schema, intl, formData });

  // @ts-expect-error
  schema.properties.styles.schema.fieldsets[0].fields = [
    // @ts-expect-error
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'title_color',
    'uppercase_title',
  ];
  // @ts-expect-error
  schema.properties.styles.schema.properties['title_color'] = {
    widget: 'color_picker',
    title: intl.formatMessage(messages.title_color_title),
    colors: [
      {
        name: 'red',
        label: 'red',
      },
      { name: 'gray', label: 'Gray' },
      {
        name: 'black',
        label: 'Black',
      },
      {
        name: 'white',
        label: 'White',
      },
    ],
    default: 'black',
  };

  // @ts-expect-error
  schema.properties.styles.schema.properties['uppercase_title'] = {
    type: 'boolean',
    title: intl.formatMessage(messages.title_style_title),
  };

  return schema;
};

export default addTitleColor;
const messages = defineMessages({
  title_color_title: {
    id: 'title_color_title',
    defaultMessage: 'Title color',
  },
  title_style_title: {
    id: 'title_style_title',
    defaultMessage: 'Uppercase title',
  },
});
